import React from 'react';
import { Card, CardContent } from '@/Components/ui/card';
import { Text } from '@/Components/ui/typography';
import { Stack, Inline } from '@/Components/ui/layout';
import { Avatar, AvatarFallback, AvatarImage } from '@/Components/ui/avatar';

function TestimonialCard({ image, quote, author, role }) {
  return (
    <Card className="bg-white rounded-lg shadow-md p-6 mb-4">
      <CardContent className="p-0">
        <Inline spacing="md" className="items-start gap-4">
          <Avatar className="w-16 h-16 rounded-full flex-shrink-0">
            <AvatarImage src={image} alt={`${author} profile`} />
            <AvatarFallback>{author.split(' ').map(n => n[0]).join('')}</AvatarFallback>
          </Avatar>
          <Stack spacing="xs" className="flex-1">
            <Text size="base" className="text-slate-700 italic leading-relaxed">
              "{quote}"
            </Text>
            <Text size="sm" className="text-slate-600 mt-2">
              - <span className="font-semibold">{author}</span>, <span>{role}</span>
            </Text>
          </Stack>
        </Inline>
      </CardContent>
    </Card>
  );
}

export default TestimonialCard;
